/**
 * Owner-pasted review JSON: parsed as an object, or refused as an invalid
 * request in the same words the server would use.
 */

import { ApiFailure } from '../../api.js';

export function parseObjectJson(value: string, label: string): Record<string, unknown> {
  let parsed: unknown;
  try {
    parsed = JSON.parse(value);
  } catch {
    throw new ApiFailure('invalid', {
      status: 400,
      detail: `${label} JSON is invalid.`,
    });
  }
  if (typeof parsed !== 'object' || parsed === null || Array.isArray(parsed)) {
    throw new ApiFailure('invalid', {
      status: 400,
      detail: `${label} JSON must be an object.`,
    });
  }
  return parsed as Record<string, unknown>;
}
